/* Variant picker: native radio groups (color swatches / pills) rendered by snippets/variant-picker.liquid.
   On change it resolves the variant from the embedded JSON and broadcasts
     document 'variant:change'  { detail: { variant, productId, source } }
   Every picker of the same product (main form + repeat CTA) stays in sync, and ?variant= is kept in the URL.
   Listeners: cro-product.js (main form, gallery, prices, sticky bar) and cro-cta.js (repeat CTA). */
(function () {
  'use strict';
  if (window.__variantPicker) { return; }
  window.__variantPicker = true;

  var D = document;
  var pickers = [];
  function $$(s, c) { return Array.prototype.slice.call((c || D).querySelectorAll(s)); }

  function parse(el) {
    var node = el.querySelector('[data-variant-json]');
    if (!node) { return []; }
    try { return JSON.parse(node.textContent) || []; } catch (e) { return []; }
  }
  function radios(fs) { return $$('input[type="radio"]', fs); }
  function selectedOptions(p) {
    return p.fieldsets.map(function (fs) {
      var r = radios(fs).filter(function (x) { return x.checked; })[0];
      return r ? r.value : null;
    });
  }
  function exact(variants, opts) {
    return variants.filter(function (v) {
      return opts.every(function (o, i) { return o === null || v.options[i] === o; });
    })[0] || null;
  }
  /* if the combination does not exist, keep the value the shopper just picked and take the best match for the rest */
  function resolve(variants, opts, changed) {
    var v = exact(variants, opts);
    if (v) { return v; }
    var keep = opts[changed];
    var cands = variants.filter(function (x) { return x.options[changed] === keep; });
    return cands.filter(function (x) { return x.available; })[0] || cands[0] || null;
  }
  function byId(variants, id) {
    id = String(id);
    return variants.filter(function (v) { return String(v.id) === id; })[0] || null;
  }

  function sync(p, variant) {
    p.fieldsets.forEach(function (fs, i) {
      var val = variant.options[i];
      radios(fs).forEach(function (r) {
        r.checked = r.value === val;
        /* a value is "unavailable" when no in-stock variant has it together with the other selected values */
        var ok = p.variants.some(function (v) {
          if (!v.available || v.options[i] !== r.value) { return false; }
          return variant.options.every(function (o, j) { return j === i || v.options[j] === o; });
        });
        var lab = r.closest ? r.closest('label') : null;
        if (lab) { lab.classList.toggle('is-unavail', !ok); }
      });
      var out = fs.querySelector('[data-option-label]');
      if (out) { out.textContent = val; }
    });
    p.el.setAttribute('data-current', variant.id);
  }

  function broadcast(variant, productId, source, updateUrl) {
    var evt = null;
    try {
      evt = new CustomEvent('variant:change', { detail: { variant: variant, productId: productId, source: source, updateUrl: updateUrl !== false } });
    } catch (e) { evt = null; }
    if (evt) { D.dispatchEvent(evt); }
  }

  D.addEventListener('variant:change', function (e) {
    var d = e.detail || {};
    if (!d.variant) { return; }
    pickers.forEach(function (p) { if (p.productId === String(d.productId)) { sync(p, d.variant); } });
    if (d.updateUrl && window.history && history.replaceState) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', d.variant.id);
        history.replaceState(history.state, '', url.toString());
      } catch (e2) { /* old browser: keep the URL */ }
    }
  });

  /* binds every picker on the page; runs again when the theme editor re-renders a section */
  function bind() {
    pickers = pickers.filter(function (p) { return D.documentElement.contains(p.el); });
    $$('[data-variant-picker]').forEach(function (el) {
      if (el.__vpBound) { return; }
      el.__vpBound = true;
      var p = { el: el, productId: String(el.getAttribute('data-product-id')), variants: parse(el), fieldsets: $$('[data-option-index]', el) };
      if (!p.variants.length || !p.fieldsets.length) { return; }
      pickers.push(p);
      el.addEventListener('change', function (e) {
        var fs = e.target && e.target.closest ? e.target.closest('[data-option-index]') : null;
        if (!fs) { return; }
        var idx = parseInt(fs.getAttribute('data-option-index'), 10) || 0;
        var v = resolve(p.variants, selectedOptions(p), idx);
        if (v) { broadcast(v, p.productId, el, true); }
      });
    });
  }
  bind();
  D.addEventListener('shopify:section:load', bind);

  /* On load: honour ?variant= (Liquid already renders it; this covers cached / restored pages).
     Runs after every deferred script so cro-product.js and cro-cta.js are listening. */
  var done = false;
  function initial() {
    if (done) { return; }
    done = true;
    var seen = {};
    var param = null;
    try { param = new URL(window.location.href).searchParams.get('variant'); } catch (e) { param = null; }
    pickers.forEach(function (p) {
      if (seen[p.productId]) { return; }
      seen[p.productId] = true;
      var cur = p.el.getAttribute('data-current');
      var target = (param && byId(p.variants, param)) || byId(p.variants, cur);
      if (target && String(target.id) !== String(cur)) { broadcast(target, p.productId, null, false); }
    });
  }
  if (D.readyState === 'complete') { initial(); } else {
    D.addEventListener('DOMContentLoaded', initial);
    window.addEventListener('load', initial);
  }
})();
